module.exports = __webpack_public_path__ + "img/can_eat.ff4fc0ee.png";